import React, { useEffect } from 'react';
import BodyContent from 'components/BodyContent';
import {
  Button,
  Card, Col, Row,
} from 'react-bootstrap';
import VariantTile from 'components/Opportunities/VariantTile';
import KpiTile from 'components/Opportunities/KpiTile';
import { ReactComponent as IconAssets } from 'assets/icons/assets.svg';
import { ReactComponent as IconEuro } from 'assets/icons/euro.svg';
import { ReactComponent as IconSchedule } from 'assets/icons/schedule.svg';
import { ReactComponent as IconMeters } from 'assets/icons/meters.svg';
import { ReactComponent as IconDownload } from 'assets/icons/download.svg';
import { ReactComponent as IconPin2 } from 'assets/icons/pin2.svg';
import { ReactComponent as IconChartBarDonut } from 'assets/icons/chart-bar-donut.svg';
import { ReactComponent as IconChartBarLine } from 'assets/icons/chart-bar-line.svg';
import { ReactComponent as IconHandEuro } from 'assets/icons/hand-euro.svg';
import HorizontalTimeline from 'components/HorizontalTimeline';
import PromotionOverview from 'components/Opportunities/PromotionOverview';
import { useLocation, useNavigate } from 'react-router';
import { PromotionDetail } from 'types/FutureInvestment';
import numeral from 'numeral';
import { formatPercentOneDecimal, formatRegularNumber } from 'utils/formats';
import MillionNumeral from 'components/MillionNumeral';
import { generateProgressData } from 'utils/promotion';

function OpportunityDetail() {
  const { state } = useLocation();
  const navigate = useNavigate();

  const promotion = state?.item as PromotionDetail | undefined;

  useEffect( () => {
    if (
      !promotion
      || typeof promotion !== 'object'
      || !promotion.tipoDeProyecto
    ) {
      navigate( -1 );
    }
  }, [promotion] );

  return (
    <BodyContent>
      <div className="op-detail">
        {!!promotion && (
          <PromotionOverview promotion={promotion} />
        )}

        {!!promotion && (
        <Row className="pt-3 g-3">
          <VariantTile
            title="Rentabilidad total después de impuestos"
            subtitle={numeral( promotion?.roiEstimadoDespuesImpuestos
              ? Number( promotion?.roiEstimadoDespuesImpuestos ) / 100 : 0 )
              .format( formatPercentOneDecimal )}
          />
          <VariantTile
            title="TIR Tasa Interna de Retorno"
            subtitle={numeral( promotion?.tirEstimadaDespuesImpuestos
              ? Number( promotion?.tirEstimadaDespuesImpuestos ) / 100 : 0 )
              .format( formatPercentOneDecimal )}
            variant="warning"
          />
          <VariantTile
            title="Holding Period"
            subtitle={`${promotion?.plazoIinversion || 0} meses`}
          />
          <VariantTile
            title="Ticket Mínimo"
            subtitle={( <MillionNumeral number={promotion?.ticketMin || 0} /> )}
          />
        </Row>
        )}
        {!!promotion && (
        <Row className="content pt-3">
          <Col>
            <Card className="card--light">
              <Card.Body className="pt-xl">
                <h1 className="title">FONDOS FINANCIADOS</h1>

                {!!promotion?.informacionProyecto && promotion.informacionProyecto.trim() !== '' && (
                <>
                  <h5 className="subtitle">Información del vehículo</h5>
                  <p className="info" style={{ whiteSpace: 'pre-line' }}>{promotion.informacionProyecto}</p>
                </>
                )}

                {!!promotion?.destinoProyecto && promotion.destinoProyecto.trim() !== '' && (
                <>
                  <h5 className="subtitle">Destino del proyecto</h5>
                  <p className="info" style={{ whiteSpace: 'pre-line' }}>{promotion.destinoProyecto}</p>
                </>
                )}

                {!!promotion?.estrategiaDesinversion && promotion.estrategiaDesinversion.trim() !== '' && (
                <>
                  <h5 className="subtitle">Estrategia de Desinversión</h5>
                  <p className="info" style={{ whiteSpace: 'pre-line' }}>{promotion.estrategiaDesinversion}</p>
                </>
                )}

                {!!promotion?.sostenibilidad && promotion.sostenibilidad.trim() !== '' && (
                <>
                  <h5 className="subtitle">Sostenibilidad</h5>
                  <p className="info" style={{ whiteSpace: 'pre-line' }}>{promotion.sostenibilidad}</p>
                </>
                )}

                {promotion?.deleted && (
                <Button variant="icon-orange" className="btn-lg w-100">
                  <IconDownload className="me-2" />
                  Descargar Dossier
                </Button>
                )}
              </Card.Body>

            </Card>
          </Col>
        </Row>
        )}
        {!!promotion && (
        <Row className="pt-3">
          <Col>
            <Card className="card--primary">
              <Card.Body className="pt-xl">
                <h1 className="subtitle">KPI’s del proyecto</h1>

                <Row>
                  <KpiTile
                    icon={<IconAssets />}
                    title="TIPO DE ACTIVO"
                    subtitle={promotion.tipoActivo || '-'}
                    className="pb-lg-4"
                  />
                  <KpiTile
                    icon={<IconEuro />}
                    title="FONDOS PROPIOS"
                    subtitle={( <MillionNumeral number={promotion?.fondosPropios1 || 0} /> )}
                  />
                  <KpiTile
                    icon={<IconMeters />}
                    title="SUPERFICIE EDIFICABLE"
                    subtitle={`${promotion?.superficieEdificable ? numeral( promotion?.superficieEdificable ).format( formatRegularNumber ) : ''} m2`}
                  />
                  <KpiTile
                    icon={<IconSchedule />}
                    title="PLAZO INVERSIÓN"
                    subtitle={`${promotion?.plazoIinversion || 0} meses`}
                  />
                  <KpiTile
                    icon={<IconPin2 />}
                    title="UBICACIÓN"
                    subtitle={promotion?.provincia?.toUpperCase() || '-'}
                  />
                  <KpiTile
                    icon={<IconChartBarDonut />}
                    title="ROE"
                    subtitle={numeral( promotion?.roiEstimadoDespuesImpuestos
                      ? Number( promotion?.roiEstimadoDespuesImpuestos ) / 100 : 0 )
                      .format( formatPercentOneDecimal )}
                  />
                  <KpiTile
                    icon={<IconChartBarLine />}
                    title="TIR FICC"
                    subtitle={numeral( promotion?.tirEstimadaDespuesImpuestos
                      ? Number( promotion?.tirEstimadaDespuesImpuestos ) / 100 : 0 )
                      .format( formatPercentOneDecimal )}
                  />
                  <KpiTile
                    icon={<IconHandEuro />}
                    title="INVERSIÓN MÍNIMA"
                    subtitle="-"
                  />
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        )}
        {!!promotion && (
        <Row className="content pt-3">
          <Col>
            <HorizontalTimeline
              steps={generateProgressData( promotion )}
            />
          </Col>
        </Row>
        )}
      </div>
    </BodyContent>
  );
}

export default OpportunityDetail;
